namespace Matrix.Administration {
    export interface PermissionSetPermissionUpdateRequest extends Serenity.ServiceRequest {
        PermissionSetCode?: string;
        Permissions?: string[];
    }
}
